module.exports = __webpack_public_path__ + "static/media/001-speed.714f1d67.svg";